import React from 'react';
import useTranslation from 'next-translate/useTranslation';
import { Accordion, Box, useMantineTheme } from '@mantine/core';
import { IconChevronRight } from '@tabler/icons-react';

import { useIsMobile } from '~/domains/common/hooks/mediaQueries';
import { Button } from '~/domains/design-system/Button';
import { Text } from '~/domains/design-system/Text';

import useStyles from './ContestNotificationWidget.styles';

function ContestNotificationWidgetHeader({
  title,
  count,
  onViewAllClick,
}: {
  title: string;
  count: number;
  onViewAllClick?: (e: React.MouseEvent) => void;
}) {
  const isMobile = useIsMobile();
  const { cx, classes } = useStyles();
  const theme = useMantineTheme();
  const { t } = useTranslation('contest');

  return (
    <Accordion.Control>
      <Box className={classes.header}>
        <Box className={cx(classes.countBadge, count > 99 && 'isCapped')}>
          <Text variant="label-small" color={theme.white} fw={600}>
            {count > 99 ? '99+' : count}
          </Text>
        </Box>
        <Text variant="label-medium" className={classes.title}>
          {title}
        </Text>
        {!isMobile && !!onViewAllClick && (
          <Button
            className={classes.viewAllButtonHeader}
            variant="primary-text"
            mode="linkButton"
            onClick={onViewAllClick}
          >
            <Text variant="body-large">{t('common.contestNotificationWidget.viewAll')}</Text>
            <IconChevronRight size={16} />
          </Button>
        )}
      </Box>
    </Accordion.Control>
  );
}

export default ContestNotificationWidgetHeader;
